import React, { useState } from "react";
import PurchaseHistoryCard from "./PurchaseHistoryCard";
import MyPageEmpty from "./MyPageEmpty";
import "../styles/PurchaseHistory.css";
import { useNavigate } from "react-router-dom";

const PurchaseHistorySection = ({ purchases }) => {
    var navigate = useNavigate();

    // ✅ 날짜별 그룹화
    const groupedPurchases = Object.entries(
        purchases.reduce((acc, item) => {
            if (!acc[item.orderDate]) acc[item.orderDate] = [];
            acc[item.orderDate].push(item);
            return acc;
        }, {})
    );

    // ✅ 페이지네이션 (5개씩 로드)
    const [visibleGroups, setVisibleGroups] = useState(5);

    const loadMoreGroups = () => {
        setVisibleGroups((prev) => prev + 5);
    };

    // ✅ orderDate (2025.03.05 16:39) 형태를 날짜와 시간으로 나누기
    const splitOrderDate = (orderDate) => {
        const [date, time] = orderDate.split(" ");
        return { date, time };
    };

    return (
        <div className="mypage-section">
            <div className="section-header">
                <h3 className="section-title">구매내역</h3>
                <button className="more-btn" onClick={() => navigate("/mypage/purchase-list")}>더보기 &gt;</button>
            </div>

            {/* 데이터가 없을 경우 */}
            {purchases.length === 0 ? <MyPageEmpty /> : (
                groupedPurchases.slice(0, visibleGroups).map(([orderDate, orderItems]) => (
                    <div key={orderDate} className="purchase-group">
                        <h4 className="purchase-date">
                            {splitOrderDate(orderDate).date.split(".")[0]}년 {splitOrderDate(orderDate).date.split(".")[1]}월 {splitOrderDate(orderDate).date.split(".")[2]}일 {splitOrderDate(orderDate).time}
                        </h4>
                        {orderItems.map(orderItem => (
                            <PurchaseHistoryCard key={orderItem.orderId} orderItems={orderItem} orderDate={orderDate} reviewPoint={orderItem.reviewPoint} />
                        ))}
                    </div>
                ))
            )}

            {/* ✅ 더보기 버튼 */}
            {groupedPurchases.length > visibleGroups && (
                <button className="mypage-load-more-btn" onClick={loadMoreGroups}>더보기 +</button>
            )}
        </div>
    );
};

export default PurchaseHistorySection;
